import React, { useState } from "react";
import { CopyIcon } from "../../../../icons/copy";
import { EditIcon } from "../../../../icons/editIcon";
import "./SuperChatUser.scss";

export const SuperChatUser = ({ message, userName, onEdit }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [copied, setCopied] = useState(false);

  const d = new Date(message.timestamp || Date.now());
  const day = d.toLocaleDateString(undefined, {
    weekday: "long",
  });
  const time = d.toLocaleTimeString(undefined, {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });

  // Use userName prop if provided, otherwise fall back to message.name or "You"
  const displayName = userName || message.name || "You";

  const handleCopy = () => {
    navigator.clipboard.writeText(message.text).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  const handleEdit = () => {
    if (onEdit) {
      onEdit(message.text);
    }
  };

  return (
    <div
      className="super-agent-bubble user-right"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="super-agent-bubble-meta">
        <span className="super-agent-user-name">{displayName}</span>
        <span className="super-agent-time">{`${day} ${time}`}</span>
      </div>
      <div className="super-agent-user-message-wrapper">
        <div className="super-agent-bubble-inner">{message.text}</div>
        <div className={`super-agent-user-actions${isHovered ? " visible" : ""}`}>
          <button
            className="super-agent-user-action-btn"
            onClick={handleEdit}
            title="Edit message"
            aria-label="Edit message"
            type="button"
          >
            <EditIcon />
          </button>
          <button
            className="super-agent-user-action-btn"
            onClick={handleCopy}
            title={copied ? "Copied!" : "Copy message"}
            aria-label="Copy message"
            type="button"
          >
            {copied ? (
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 10l4 4 8-8" stroke="#4CAF50" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            ) : (
              <CopyIcon />
            )}
          </button>
        </div>
      </div>
    </div>
  );
};
